import { useEffect, useState } from 'react';
import { graphql } from '../api/client';
import { useAuth } from '../auth/AuthProvider';

type Outcome = 'KEPT' | 'ADDRESS_CHANGED' | 'REPLACED' | 'LEFT_OFF' | 'ADDED' | 'NONE';
type County = { state: string; county: string; notices: number; outcomes: Record<Outcome, number> };
const columns: Array<[Outcome, string]> = [['KEPT', 'Kept as found'], ['ADDRESS_CHANGED', 'Address changed'], ['REPLACED', 'Someone else'],
  ['LEFT_OFF', 'Left off'], ['ADDED', 'Customer added']];

/**
 * How research did by county, judged by the customers who confirmed its suggestions: each confirmed notice is a known
 * answer from real use. Worst counties first, so the ones needing work are at the top.
 */
export function ResearchAccuracy() {
  const { token } = useAuth();
  const [counties, setCounties] = useState<County[] | null>(null);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!token) return;
    graphql<{ researchAccuracy: County[] }>({ query: 'query ResearchAccuracy { researchAccuracy(days: 180) }', token })
      .then(data => setCounties(data.researchAccuracy)).catch((reason: Error) => setError(reason.message));
  }, [token]);
  return <section className="workspace-section" aria-label="How research did, by county">
    <div className="section-heading"><div><h2>How research did, by county</h2>
      <p>What customers kept of research’s recipients when they confirmed a notice in the last 180 days, counted recipient role by role. Counties with the most changes are first.</p></div></div>
    {error && <div className="alert error">{error}</div>}
    {counties && !counties.length && <p className="empty-note">No notices have been confirmed yet.</p>}
    {counties && counties.length > 0 && <div className="data-table" tabIndex={0}><table>
      <thead><tr><th>County</th><th>Notices</th>{columns.map(([, label]) => <th key={label}>{label}</th>)}</tr></thead>
      <tbody>{counties.map(county => <tr key={`${county.state}-${county.county}`}><td>{county.county}, {county.state}</td><td>{county.notices}</td>
        {columns.map(([outcome]) => <td key={outcome}>{county.outcomes[outcome]}</td>)}</tr>)}</tbody>
    </table></div>}
  </section>;
}
